import * as React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import reportWebVitals from './reportWebVitals';

import '@scss/browserResets.scss';
import '@scss/app.scss';

const rootElement = document.getElementById('root');

// Ensure the root element exists in your `public/index.html`
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement); // Use createRoot instead of render
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
